module.exports = __webpack_public_path__ + "fonts/effect-mental-immunity-b033e4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/effect-mental-immunity.svg
// module id = 789
// module chunks = 0